import { PLN } from '@constants/currencies'
import { formatPrice } from '@helpers/payment'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Badge } from '@ui-kit'
import { useTranslation } from 'react-i18next'

export const SaveAmountOnBadge = () => {
  const { t } = useTranslation()

  const {
    accountCurrency,
    getAnnualSavingPrice,
    checkoutDataInContext: { chosenRecordKey }
  } = useCheckoutContext()

  if (!chosenRecordKey) return null

  const annualSavingPrice = getAnnualSavingPrice(chosenRecordKey)

  return (
    <Badge variant='warning20-filled' weight={600} isTextUppercase={false}>
      {t('compare.plans.save', {
        saveValue: formatPrice(annualSavingPrice),
        currency: accountCurrency
      })}{' '}
      {accountCurrency === PLN && t('word.net')}
    </Badge>
  )
}
